import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { BaseService } from 'src/app/core/services/base.service';

@Injectable({
  providedIn: 'root'
})
export class SharedFeaturedService extends BaseService {

  constructor(private http: HttpClient) { super(); }

  /**
   * getFeatured() - Buscar notícia em destaque do departamento
   * @param departmentType : Departamento das notícias 
   */
  getFeatured(departmentType): Observable<any> {
    
    // Instancia do body através de BaseService.setBody();
    let body = this.setBody();
    // limit: Definir o retorno máximo de últimas notícias
    body.set('session_type', '1');
    // Inicializar o tipo do departamento selecionado
    body.set('departmentType', departmentType);
    // Inicializar notícia em destaque (futured)
    body.set('futured', 1);

    let response = this.http
      .post(this.urlService + this.routeAdress.route_news_featured, body.toString())
      .pipe(
        map(this.extractData),
        catchError(this.serviceError));

    return response;
  }

}
